
import { ref, inject, shallowRef, reactive } from "vue";
import Header from "@/components/header/header.vue"; 
import OrderGoods from "@/components/goods/order-goods.vue";
import Address from '@/components/address/index.vue'
import OrderPrice from '@/components/order/order-price.vue'
import { useRoute } from "vue-router"; 
import { Notify } from 'vant';
import { GetPayFn } from "@/hooks/index";
import { Toast, Dialog } from "vant";
import payNowPopup from '@/components/pay-now-popup/payNowPopup.vue'
import router from '@/router';
export default {
  components: {
    Header,
    OrderGoods,
    Address,
    OrderPrice,
    payNowPopup
  },
  props: {},
  setup(props: object) {
    const $http: any = inject("$http");
    const  $store: any = inject("$store");
    const currencyUnit:String = $store.getSymbol();
    const finished = ref(false);
    const route: any = useRoute();
    const m_pesa_show = ref(false);
    const m_pesa_phone = ref('');
    const mpesa_loading = ref(false);
    const m_pesa_error_msg_show = ref(false);
    
    let orderInfo = shallowRef({
      sn:'',
      pay_sn:'',
      logistics: 0
    })
   let order_price_obj: any = reactive({
            voucher_price: 0,
            goods_discount: 0,
            pay_amount: 0,
            order_mansong_discount: 0,
            coin_redeemed_price: 0,
            tax_total: 0,
            shipping_fee: 0,
            goods_order_amount: 0,
            promos_discount:0,
            tax_shipping_discount:0, 
          })
    let isShowPayPop = ref(false);
     let payInfo = reactive({
      receiver: {
        phone: "",
        firstname:''
      },
      pay_sn: "",
      amount_goods: "",
      amount_pay:'',
    });     
    const getOrderInfoFn = async() => {
        let sn = ref(null)
        let pay_sn = ref(null)
        if(route.query.id && route.query.id.indexOf(",") > -1){
                let sn_arr = route.query.id.split(",");
                sn.value = sn_arr[0];
                pay_sn.value = sn_arr[1];
            }
            else{
                sn = route.query.id;
            }
        let ret = await $http.order_info({ sn: sn.value , pay_sn: pay_sn.value })
        if(ret.code == 200) {
          orderInfo.value = ret.data
          order_price_obj.goods_discount =  ret.data.goods_discount 
          order_price_obj.goods_order_amount =  ret.data.amount_goods
          order_price_obj.coin_redeemed_price =  ret.data.coin_discount
          order_price_obj.shipping_fee =  ret.data.amount_freight + ret.data.common.platform_postage_discount
          order_price_obj.shipping_discount =  ret.data.shipping_discount 
          order_price_obj.promos_discount =  ret.data.promos_discount
          order_price_obj.tax_shipping_discount =  ret.data.common.platform_postage_discount
          order_price_obj.tax_total = ret.data.tax_total
          order_price_obj.vat_show_status = ret.data.vat_show_status
          payInfo.receiver = ret.data.receiver;
          m_pesa_phone.value =  ret.data.receiver.phone
          payInfo.receiver.firstname = ret.data.receiver.firstname
          payInfo.pay_sn = ret.data.pay_sn;
          payInfo.amount_pay = ret.data.amount_pay;
          // if(ret.data.tracking_code) {
            // logistics_info_fn(ret.data.tracking_code);
          // }
        }
      
    }
    getOrderInfoFn()
     const closePopupFn = (e:boolean) => {
     isShowPayPop.value = e
   }
   const openOpopup = () => {
      isShowPayPop.value = true
   }
    const onCopy = (e: any) => {
        Notify({ type: 'success', message: 'Copy success!' });
    };
    const onError = (e: any) => {
        Notify({ type: 'warning', message: 'The browser does not support automatic replication!' });
    };
     // 取消订单
    const click_cancel_fn = () => {
      Dialog.confirm({
        //是否取消这些商品
        message: "Are you sure cancel?",
        confirmButtonText: "Yes",
        cancelButtonText: "No",
      })
        .then(() => {
          review_message_post_fn(payInfo, "buyer_cancel");
        })
        .catch(() => {
          Toast({
            message: "Undelete",
          });
        });
    };
    /**
     * 订单操作
     */
    const review_message_post_fn = async (payInfo: any, action: any) => {
      // loading.value = true;
      let ret = await $http.order_change_state({
        action: action,
        sn: orderInfo.value.sn,
        pay_sn: orderInfo.value.pay_sn,
      });
      // loading.value = false;
      if (ret.code === 200) {
        Toast({
          type: "success",
          message: "successfully!",
        });
        // get_orders_list();
        router.go(-1)
      }
    };
    // 删除
    const click_delete_fn = ( ) => {
      Dialog.confirm({
        //是否删除这些商品
        message: "Are you sure delete?",
        confirmButtonText: "YES",
        cancelButtonText: "NO",
      })
        .then(() => {
         review_message_post_fn(payInfo, "buyer_delete");
        })
        .catch(() => {
          Toast({
            message: "Undelete",
          });
        });
    };
    const goGoodsFn = (id:any) => {
      router.push({
              name:'goods',
              params:{
                id:id
              }
            })
    }
    /**
       * m-pesa 支付
       */
      const m_pesa_submit_fn = () => {
        mpesa_loading.value = true;
        let phone_val = m_pesa_phone.value || ''
        phone_val = String(phone_val).replace(/(^254*)/g, '')
        if(m_pesa_phone.value === '' || !new RegExp(/^[0]{1}[1-9]{1}[0-9]{8}$|^[1-9]{1}[0-9]{8}$/).test(phone_val)){
            m_pesa_error_msg_show.value = true;
            mpesa_loading.value = false;
            return;
        }
        m_pesa_show.value = false
        m_pesa_error_msg_show.value = false;
        router.push(
          `/mpesa?phone=${phone_val}&pay_sn=${payInfo.pay_sn}`
        );
      };
      const m_pesa_showFn = (e:boolean) => {  
        m_pesa_show.value = e
      }
      const checkLogistics= function () {
        if(!localStorage.getItem('access_token')){
            Toast("Please Log In");
           setTimeout(()=>{
             router.push("/login");
           },2000)
      }else{    
        // console.log(`${window.common.old_url()}/logistics/${orderInfo.value.sn}`)
        if(orderInfo.value.logistics == 1) {
          // location.href = `${window.common.old_url()}/logistics/${orderInfo.value.sn.toString().substring(0,orderInfo.value.sn.toString().length-2)}`
          router.push(`/logistics/${orderInfo.value.sn.toString().substring(0,orderInfo.value.sn.toString().length-2)}`)
        } else {
          router.push(`/logistics/${orderInfo.value.sn}`)
        }
      } 
    }
     /**
     * 获取订单物流轨迹
     */
    // let logistics_datas = reactive({logistics_datas:[]})
    // const  logistics_info_fn = async (tracking_code:any) => {
    //     let ret = await $http.logistics_info({ tracking_code: tracking_code });
    //     if(ret.code === 200 && ret.data){
    //         logistics_datas.logistics_datas = ret.data.logistics_datas;
    //         console.log(logistics_datas)
    //     }

    // }
    let click_aftersale_fn = () => {
      router.push(`/afterSale?name=state_apply&order_sn=${orderInfo.value.sn}`)
    }
    return {
      orderInfo,
      order_price_obj,
      payInfo,
      isShowPayPop,
      closePopupFn,
      openOpopup,
      currencyUnit,
      onCopy,
      onError,
      click_cancel_fn,
      click_delete_fn,
      goGoodsFn,
      m_pesa_show,
      m_pesa_error_msg_show,
      mpesa_loading,
      m_pesa_phone,
      m_pesa_showFn,
      m_pesa_submit_fn,
      checkLogistics,
      // logistics_datas,
      click_aftersale_fn,
      route
    } 
  },
};
